import { connect } from 'react-redux'
import compose from 'recompose/compose'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import StopsList from '../components/stopslist/StopsList'
import { showStopFaderDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { InteractiveListStates } from 'aria-viewer/interactive-element'

const mapStateToProps = (state, ownProps) => {
    const { stopsList, stopIndex, isMapEnabled } = mapSelectorsToProps(['stopsList', 'stopIndex', 'isMapEnabled'])()(
        state,
        ownProps
    )
    const interactiveElementsListState = state.getIn(['interactiveElements', 'interactiveElementsListState'])

    const list = (stopsList || []).reduce(
        (stopList, stop, ii) =>
            ii - stopIndex >= -1 && ii - stopIndex <= 3
                ? [
                      ...stopList,
                      {
                          title: stop.title,
                          ii,
                      },
                  ]
                : stopList,
        []
    )

    return {
        isMapEnabled,
        list,
        stopListLength: stopsList.size,
        index: stopIndex,
        interactiveElementsListState,
    }
}

const mapDispatchToProps = dispatch => ({
    handleShowStopFadeDrawer: e => {
        dispatch(showStopFaderDrawer(e.pageY, true))
    },
})

const mergeProps = (state, actions, ownProps) => ({
    ...state,
    ...actions,
    ...ownProps,

    onMouseEnter: e => {
        if (state.interactiveElementsListState != InteractiveListStates.EXPANDED) actions.handleShowStopFadeDrawer(e)
    },

    onKeyPress: e => {
        actions.handleShowStopFadeDrawer(e)
    },
})

export default compose(connect(mapStateToProps, mapDispatchToProps, mergeProps))(StopsList)
